module.exports = __webpack_public_path__ + "media/images/pages/team-7-8a13cbf1fd55ab7cea9c1837070a16e1.jpg";